// src/data/exercises/L3_06.js

const accountOptions = [
  '租税公課', '仮払消費税', '所得税預り金', '土地', '当座預金'];

export const L3_06 = {
  title: '簿記　3級（第219-6回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

    parts: [
        { type: 'ruby', text: '沖縄', ruby: 'おきなわ' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は、' },
        { type: 'ruby', text: '店舗', ruby: 'てんぽ' },
        { type: 'text', value: 'と' },
        { type: 'ruby', text: '土地', ruby: 'とち' },
        { type: 'text', value: '・' },
        { type: 'ruby', text: '建物', ruby: 'たてもの' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '関', ruby: 'かん' },
        { type: 'text', value: 'する' },
        { type: 'ruby', text: '固定資産税', ruby: 'こていしさんぜい' },
        { type: 'text', value: '￥240,000を' },
        { type: 'ruby', text: '当座預金口座', ruby: 'とうざよきんこうざ' },
        { type: 'text', value: 'から' },
        { type: 'ruby', text: '納付', ruby: 'のうふ' },
        { type: 'text', value: 'した。' }
    ]
    
    ,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '租税公課', debitAmount: 240000, creditAccount: '当座預金', creditAmount: 240000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '店舗と土地・建物に関する固定資産税 \n' },
          { type: 'text', value: '①固定資産税なので、租税公課が発生します。\n' },
          { type: 'styled', value: '租税公課の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '当座預金口座から納付 \n' },
          { type: 'text', value: '②当座預金口座から納付＝当座預金から支払った　となるので\n' },
          { type: 'text', value: '当座預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '当座預金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`店舗と土地・建物に関する固定資産税
①固定資産税なので、租税公課が発生します。

当座預金口座から納付
②当座預金口座から納付＝当座預金から支払った　となるので
当座預金が減少（マイナス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
              parts: [
          { type: 'text', value: '店舗と土地・建物に関する固定資産税 \n' },
          { type: 'text', value: '①固定資産税なので、租税公課が発生します。\n' },
          { type: 'styled', value: '租税公課の発生は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '当座預金口座から納付 \n' },
          { type: 'text', value: '②当座預金口座から納付＝当座預金から支払った　となるので\n' },
          { type: 'text', value: '当座預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '当座預金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};